"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCaretPosition = void 0;

const getPrefixPosition = prefix => {
  return prefix ? prefix.length + 1 : 0;
};

const getSuffixPosition = (endPosition, suffix) => {
  return suffix ? endPosition - (suffix.length + 1) : endPosition;
};

const getCaret = (elem, prefix, suffix) => {
  const start = elem.selectionStart;
  const end = elem.value.length;
  const suffixPosition = getSuffixPosition(end, suffix);
  const prefixPosition = getPrefixPosition(prefix);
  let position = start;

  if (position < prefixPosition) {
    position = prefixPosition;
  }

  if (position > suffixPosition) {
    position = suffixPosition;
  }

  return position;
};

const setCaretPosition = (elem, prefix, suffix) => {
  const position = getCaret(elem, prefix, suffix);

  if (elem.setSelectionRange) {
    elem.setSelectionRange(position, position);
    elem.focus();
  } else {
    const range = elem.createTextRange();
    range.collapse(true);
    range.moveEnd('character', position);
    range.moveStart('character', position);
    range.select();
  }
};

exports.setCaretPosition = setCaretPosition;